import { render, staticRenderFns } from "./guanjiaDialog.vue?vue&type=template&id=b46b467e&scoped=true&"
import script from "./guanjiaDialog.vue?vue&type=script&lang=js&"
export * from "./guanjiaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46b467e",
  null
  
)

export default component.exports